module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"close()\">&times;</button> <b class=\"modal-title\">{{:: 'Состояние базы данных' | gettext }}</b></div><div class=\"modal-body\"><b>{{:: interpolate(gettext('Занято %s% объема диска.'), [databaseUsage]) }}</b><div>{{:: interpolate(gettext('Путь до базы данных: %s'), [databasePath]) }}</div></div><div class=\"modal-footer\"><div class=\"btn-group\"><button class=\"btn\" ng-click=\"close()\">{{:: 'Закрыть' | gettext }}</button></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin/database-usage-modal.component.html
// module id = 427
// module chunks = 0